/* eslint-disable
    func-names,
    no-sequences,
    no-unused-expressions,
    no-unused-vars,
    no-use-before-define,
    no-var,
    one-var,
    vars-on-top,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const deps = ['$scope', 'DocumentCollection', '$state'];

const DocumentCardCtrl = function ($scope, DocumentCollection, $state) {
  let adjustedLength, array, day;
  this.years = _.range(2010, new Date().getFullYear() + 1).reverse();
  this.months = [
    {
      name: 'January',
      value: 1,
    },
    {
      name: 'February',
      value: 2,
    },
    {
      name: 'March',
      value: 3,
    },
    {
      name: 'April',
      value: 4,
    },
    {
      name: 'May',
      value: 5,
    },
    {
      name: 'June',
      value: 6,
    },
    {
      name: 'July',
      value: 7,
    },
    {
      name: 'August',
      value: 8,
    },
    {
      name: 'September',
      value: 9,
    },
    {
      name: 'October',
      value: 10,
    },
    {
      name: 'November',
      value: 11,
    },
    {
      name: 'December',
      value: 12,
    },
  ];

  this.headerLabels = {
    STATEMENT: 'All Statements',
    NOT_STATEMENT: 'Other Documents',
    RECEIPT: 'Receipts',
    TAX: 'Tax',
    EXPORTS: 'Exports',
    INTERNAL: 'Internal',
    ADDONS: 'All Add-Ons',
  };

  $scope.$on('bl-document-upload-success', () => {
    documents.$fetch();
  });

  this.header = function () {
    if (this.archived && this.documentType === 'STATEMENT') {
      return 'Archived';
    } else if (this.archived != null && !this.archived && this.documentType === 'STATEMENT') {
      return 'Unprocessed';
    }
    return this.headerLabels[this.documentType];
  };

  // decode the date
  (array = this.date.split('-')),
    (adjustedLength = Math.max(array.length, 1)),
    ([this.month, day] = Array.from(array.slice(0, adjustedLength - 1))),
    (this.year = array[adjustedLength - 1]);
  if (this.year === 'all') {
    this.year = '';
  }

  const getFormatedDate = function (month, year) {
    let date = '';
    if (year != null && year !== '') {
      date = `${year}`;
      if (month != null && month !== '') {
        date = `${month}-01-${date}`;
      }
    }
    return date;
  };

  this.navigate = () =>
    $state.go('.', {
      clientId: this.clientId,
      date: getFormatedDate(this.month, this.year),
      query: this.fileNameSearch,
      page: 1,
    });

  this.changePage = () =>
    $state.go('.', {
      clientId: this.clientId,
      date: getFormatedDate(this.month, this.year),
      query: this.fileNameSearch,
      page: this.selectedPage,
    });

  this.clearSearchForm = () => {
    this.fileNameSearch = '';
    return this.navigate();
  };

  var documents = new DocumentCollection({
    clientId: this.clientId,
    documentType: this.documentType,
    year: this.year,
    month: this.month,
    page: this.page,
    ledgerId: this.ledgerId,
    addOnId: this.addOnId,
    archived: this.archived,
    fileName: this.fileName,
  });
  if (this.refetch) {
    documents.$fetch();
  }
  documents.$cacheAllModels();

  this.fileNameSearch = this.fileName;

  documents.$promise.then(() => {
    this.documents = documents;
    this.selectedPage = this.page;
    this.resultsPerPage = this.documents.resultsPerPage;
    return (this.totalResults = this.documents.totalResults);
  });
};

DocumentCardCtrl.$inject = deps;

module.exports = DocumentCardCtrl;
